export default {"src":"/_next/static/media/logo-vivaldis.2a11752c.svg","height":88,"width":167,"blurWidth":0,"blurHeight":0};